declare global {
  interface Window {
    Moengage: any;
    moe: any;
    moengage_q: any[];
  }
}

export const getMoEngageScript = (
  cluster: string = 'dc_3',
  debug_logs: number = 1,
  app_id: string,
): string => {
  const normalizedCluster = cluster.toLowerCase();
  return `
  if (!('${app_id}') || '${app_id}'.trim() === '' || (window.Moengage && typeof window.Moengage.track_event === 'function')) {
    console.warn('[MoEngage] Skipping initialization: moengage_app_id is missing or empty');
  } else {
    !function(e,n,i,t,a,r,o,d){var s=e[a]=e[a]||[];if(s.invoked=0,s.initialised>0||s.invoked>0)return console.error("MoEngage Web SDK initialised multiple times. Please integrate the Web SDK only once!"),!1;e.moengage_object=a;var l={},g=function n(i){return function(){for(var n=arguments.length,t=Array(n),a=0;a<n;a++)t[a]=arguments[a];(e.moengage_q=e.moengage_q||[]).push({f:i,a:t})}},u=["track_event","add_user_attribute","add_first_name","add_last_name","add_email","add_mobile","add_user_name","add_gender","add_birthday","destroy_session","add_unique_user_id","moe_events","call_web_push","track","location_type_attribute"],m={onsite:["getData","registerCallback"]};for(var c in u)l[u[c]]=g(u[c]);for(var v in m)for(var f in m[v])null==l[v]&&(l[v]={}),l[v][m[v][f]]=g(v+"."+m[v][f]);r=n.createElement(i),o=n.getElementsByTagName("head")[0],r.async=1,r.src=t,o.appendChild(r),e.moe=e.moe||function(){return(s.invoked=s.invoked+1,s.invoked>1)?(console.error("MoEngage Web SDK initialised multiple times. Please integrate the Web SDK only once!"),!1):(d=arguments.length<=0?void 0:arguments[0],l)},r.addEventListener("load",function(){if(d)return console.log('[MoEngage] SDK loaded successfully'),e[a]=e.moe(d),e[a].initialised=e[a].initialised+1||1,!0}),r.addEventListener("error",function(){return console.error("Moengage Web SDK loading failed."),!1})}(window,document,"script","https://cdn.moengage.com/webpush/moe_webSdk.min.latest.js","Moengage");
    Moengage = moe({
      app_id:'${app_id}',
      debug_logs:${debug_logs},
      cluster: '${normalizedCluster}',
    });
  }
  `;
};

export const getMoEngageWebPushScript = (
  cluster: string = 'dc_3',
  debug_logs: number = 1,
  app_id: string,
): string => {
  const normalizedCluster = cluster.toLowerCase();
  return `
  if (!('${app_id}') || '${app_id}'.trim() === '' || (window.Moengage && typeof window.Moengage.track_event === 'function')) {
    console.warn('[MoEngage] Skipping initialization: moengage_app_id is missing or empty');
  } else {
    !function(e,n,i,t,a,r,o,d){if(!"${normalizedCluster}"||!"${normalizedCluster}".match(/^dc_[0-9]+$/gm))return console.error("Data center has not been passed correctly. Please follow the SDK installation instruction carefully.");var s=e[a]=e[a]||[];if(s.invoked=0,s.initialised>0||s.invoked>0)return console.error("MoEngage Web SDK initialised multiple times. Please integrate the Web SDK only once!"),!1;e.moengage_object=a;var l={},g=function n(i){return function(){for(var n=arguments.length,t=Array(n),a=0;a<n;a++)t[a]=arguments[a];(e.moengage_q=e.moengage_q||[]).push({f:i,a:t})}},u=["track_event","add_user_attribute","add_first_name","add_last_name","add_email","add_mobile","add_user_name","add_gender","add_birthday","destroy_session","add_unique_user_id","update_unique_user_id","moe_events","call_web_push","track","location_type_attribute"],m={onsite:["getData","registerCallback"]};for(var c in u)l[u[c]]=g(u[c]);for(var v in m)for(var f in m[v])null==l[v]&&(l[v]={}),l[v][m[v][f]]=g(v+"."+m[v][f]);r=n.createElement(i),o=n.getElementsByTagName("head")[0],r.async=1,r.src=t,o.appendChild(r),e.moe=e.moe||function(){return(s.invoked=s.invoked+1,s.invoked>1)?(console.error("MoEngage Web SDK initialised multiple times. Please integrate the Web SDK only once!"),!1):(d=arguments.length<=0?void 0:arguments[0],l)},r.addEventListener("load",function(){if(d)return e[a]=e.moe(d),e[a].initialised=e[a].initialised+1||1,!0}),r.addEventListener("error",function(){return console.error("Moengage Web SDK loading failed."),!1})}(window,document,"script","https://cdn.moengage.com/release/${normalizedCluster}/moe_webSdk.min.latest.js","Moengage");
    if (!window.Moengage || typeof window.Moengage.track_event !== 'function') {
      Moengage = moe({
        app_id: '${app_id}',
        debug_logs: ${debug_logs},
        swScope: '/',
      });
    }
  }
  `;
};

export const trackEventGeneric = (eventName: string, payload: any): void => {
  if (window.Moengage) {
    window.Moengage.track_event(eventName, payload);
  }
};

export const addFirstName = (firstName: string): void => {
  if (window.Moengage) {
    window.Moengage.add_first_name(firstName);
  }
};

export const addLastName = (lastName: string): void => {
  if (window.Moengage) {
    window.Moengage.add_last_name(lastName);
  }
};

export const addEmail = (email: string): void => {
  if (window.Moengage) {
    window.Moengage.add_email(email);
  }
};

export const addMobile = (mobile: string): void => {
  if (window.Moengage) {
    window.Moengage.add_mobile(mobile);
  }
};

export const addClientId = (clientId: string): void => {
  if (window.Moengage) {
    window.Moengage.add_user_attribute('client_id', clientId);
  }
};

export const addSessionId = (sessionId: string): void => {
  if (window.Moengage) {
    window.Moengage.add_user_attribute('session_id', sessionId);
  }
};

export const addUniqueUserId = async (userId: string): Promise<void> => {
  if (window.Moengage) {
    await window.Moengage.add_unique_user_id(userId);
  }
};

export const destroySession = (): void => {
  if (window.Moengage) {
    window.Moengage.destroy_session();
  }
};

export const isMoengageObjPresent = (): boolean => {
  return typeof window.Moengage !== 'undefined' && window.Moengage !== null;
};
